import {NgModule} from '@angular/core';
import {Routes, RouterModule} from '@angular/router';


const routes: Routes = [
    {
        path: '',
        redirectTo: 'login'
    }, {
        path: 'login',
        loadChildren: () => import('./login/login.module').then(mod => mod.LoginModule)
    }, {
        path: 'recupera-password',
        loadChildren: () => import('./remember-password/remember-password.module').then(mod => mod.RememberPasswordModule)
    }];

@NgModule({
    imports: [RouterModule.forChild(routes)],
    exports: [RouterModule]
})
export class AuthRoutingModule {
}
